const Randy = {
  level1: '#E0F8F8',
  Ra100: '#E0F8F8',
  level2: '#B2EDEE',
  Ra200: '#B2EDEE',
  level3: '#80E1E4',
  Ra300: '#80E1E4',
  level4: '#1DCAD3',
  Ra400: '#1DCAD3',
  level5: '#00B0BC',
  Ra500: '#00B0BC',
  level6: '#00878B',
  Ra600: '#00878B',
};

export { Randy };
